var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mainLogic && _vm.mainLogic.filiale)?_c('div',[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }